import { useQuery } from '@apollo/react-hooks';
import CircularProgressIndicator from "../elements/CircularProgressIndicator"
import { USERS_QUERY } from "../../queries/Queries"
import { Component } from "react"
import { AUTH_TOKEN } from "../../constants"
import AdvertisementLogBarChart from './AdvertisementLogBarChart';
import { flattenStrapiData } from '../../utils/utilities';

class AdvertisementLogStatistic extends Component {
    
    render() {
        const token = localStorage.getItem(AUTH_TOKEN)
        
        if(!token) {
          return(
            <div>
              <span className="Error">You must be loged in first</span>
            </div>
          )
        }

        return <GetList sortBy="id:asc"/>
    }
}

function GetList({sortBy}) {
    const {data, loading, error} = useQuery(USERS_QUERY, {variables: {sortBy: sortBy, limit: 50}})
    
    if(loading) return(<CircularProgressIndicator size={60} />)
    
    if(error) {   
      console.log(error)
     return(<span className="error">{error.message}</span>)
    }
    
    let users = flattenStrapiData(data.usersPermissionsUsers)
    let usersWithLogs = users.filter((user) => user.advertisement_log !== null && (user.advertisement_log.interstitial_load_amount > 0 || user.advertisement_log.banner_load_amount > 0))
    return (
        <div>
            <AdvertisementLogBarChart 
                users={usersWithLogs}
            />
        </div>
    )
}

export default AdvertisementLogStatistic